import React, { useState } from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import className from 'classnames';
import { useForm } from 'react-final-form';
import { useIntl } from 'react-intl';
import styles from './styles.css';
import FieldAccordion from '../../FieldAccordion';
import FieldControls from '../../FieldControls';
import DrivedFieldLabel from './DrivedFieldLabel';

function DrivedFieldAccordion({
  fieldData,
  fields,
  snapshot,
  draggableProvided,
  fieldName,
  fieldIndex,
}) {
//   const [isOpen, setIsOpen] = useState(true);
  const usePortal = snapshot.isDragging;
  const { formatMessage } = useIntl();
  const { getState } = useForm();
  const primaryList = getState().values.availableLists.find(
    (list) => list.isPrimary === true,
  );
  const fieldSource = fieldData.fieldArray.find(
    (data) => data.name === primaryList?.name,
  );
  const DrivedField = (
    <div
      ref={draggableProvided.innerRef}
      {...draggableProvided.draggableProps}
      className={className(styles.DrivedFieldWrapper, {
        [`${styles['DrivedFieldWrapper--dragging']}`]: snapshot.isDragging,
      })}
      role="button"
    >
      <FieldAccordion
        key={`${fieldName}-drived-field-accordion-${fieldIndex}`}
        id={`${fieldName}-drived-field-accordion-${fieldIndex}`}
        label={formatMessage({
          id: `ui-inventory.${fieldSource?.dataOptionsSource}.name.${fields.value[fieldIndex].name}`,
          defaultMessage: fields.value[fieldIndex].name,
        })}
        fieldName={fieldName}
        fieldData={fields.value[fieldIndex]}
        index={fieldIndex}
        dragHandleProps={draggableProvided.dragHandleProps}
        // open={isOpen}
        // onToggle={() => setIsOpen(!isOpen)}
        separator={fieldIndex !== 0}
        closedByDefault
      >
        <FieldControls
          fieldData={fields.value[fieldIndex]}
          fieldName={fieldName}
          fieldType="drivedField"
          hasBorder
        />
        <DrivedFieldLabel
          fieldName={fieldName}
          fieldData={fields.value[fieldIndex]}
          fieldSource={fieldSource?.dataOptionsSource}
        />
      </FieldAccordion>
    </div>
  );

  if (!usePortal) {
    return DrivedField;
  }

  const container = document.getElementById('OverlayContainer');
  return ReactDOM.createPortal(
    DrivedField,
    container,
    'drived-field-accordion',
  );
}

DrivedFieldAccordion.propTypes = {
  fieldData: PropTypes.object,
  fields: PropTypes.object,
  fieldName: PropTypes.string,
  fieldIndex: PropTypes.number,
  snapshot: PropTypes.object,
  draggableProvided: PropTypes.object,
};

export default DrivedFieldAccordion;
